import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from './preloader.module.scss';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'Preloader';
var PreloaderComponent = memo(function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.color, color = _d === void 0 ? 'dark-purple' : _d;
    return (React.createElement("div", { className: cn(BLOCK_NAME), "data-name": "Preloader" },
        React.createElement("div", { className: cn('Preloader__circular', (_b = {},
                _b["".concat(BLOCK_NAME, "__circular--").concat(size)] = Boolean(size),
                _b["".concat(BLOCK_NAME, "__circular--").concat(color)] = Boolean(color),
                _b)) })));
});
/**
 * Компонент для отображения индикатора загрузки
 */
export var Preloader = memo(PreloaderComponent);
